import {Entity} from '../core/entity/core.base.entity';
import {Column} from '../core/entity/core.entity.column';
import {JoinColumn} from '../core/entity/core.entity.join.column';
import {EntityTable} from '../core/entity/core.entity.table.decorator';
import {EnvironmentKind} from '../enum/environment.kind';
import {FieldRelationKind} from '../enum/field.relation.kind';
import {FieldTypeKind} from '../enum/field.type.kind';
import {SystemEntity} from './system.entity';

@EntityTable('flow_queue', 'cd76a433-e2b7-4b6a-b33a-39df0ac68468')
export class FlowQueueEntity extends Entity {

    @Column(FieldTypeKind.STRING)
    public name: string;

    @JoinColumn(FieldTypeKind.GUID, SystemEntity, true, false, FieldRelationKind.BELONGS_TO, 'system')
    public systemId: string;

    @Column(FieldTypeKind.ANY)
    public options: any;

    @Column(FieldTypeKind.GUID, false, false, true)
    public aliasId: string;

    @Column(FieldTypeKind.ENUM, false)
    public environmentKind: EnvironmentKind;

}
